import type { Phone } from 'entities/Phone/model/Phone'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import type { IInboxTreeCombine } from 'entities/Inbox'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export const searchFilter = (
  inbox: IInboxTreeCombine,
  search: string,
  entities: IEntitiesStore
) => {
  let numbers: Phone[] = []
  const inboxes: Inbox[] = []
  const searchByName = inbox.name.toUpperCase().includes(search.toUpperCase())

  if (inbox.type === 'inbox_group') {
    const teamsNumberIds = inbox.teamsIds
      .map((id) => {
        const inboxTemp = entities.inboxesStore.getItem(id)

        if (inboxTemp?.type !== 'inbox') return []

        return inboxTemp?.numberIds
      })
      .filter((item) => item)
      .reduce((state, ids) => {
        return [...(state ? state : []), ...(ids ? ids : [])]
      }, [])

    inbox.teamsIds.map((id) => {
      const inboxTemp = entities.inboxesStore.getItem(id)

      if (inboxTemp?.type !== 'inbox') return null

      inboxes.push(inboxTemp)
    })

    numbers = Array.isArray(teamsNumberIds)
      ? teamsNumberIds.reduce<Phone[]>((state, id) => {
          const item = entities.numbersStore.getItem(id)

          return item ? [...state, item] : state
        }, [])
      : []
  } else if (inbox.type === 'inbox') {
    numbers = inbox.numberIds.reduce<Phone[]>((state, id) => {
      const item = entities.numbersStore.getItem(id)

      return item ? [...state, item] : state
    }, [])
  }

  const hasNameIntersection =
    searchByName ||
    !!inboxes.filter((inbox) => inbox.name.toUpperCase().includes(search.toUpperCase())).length
  const hasFormattedNumber = !!numbers
    .map((number) => number?.formatted_number)
    .filter((number) => number?.includes(search)).length
  const hasNationalNumber = !!numbers
    .map((number) => number?.national_number)
    .filter((number) => number?.includes(search)).length
  const hasNumber = !!numbers
    .map((number) => number?.number)
    .filter((number) => number?.includes(search)).length

  return Boolean(
    searchByName || hasFormattedNumber || hasNationalNumber || hasNumber || hasNameIntersection
  )
}
